import { Sidebar } from "../../shared/components";
import { AuthGuard } from "../../shared/guards/AuthGuard";
import { FinancialPresentation } from "./components/FinancialPresentation";

export const FinancialPage = (): JSX.Element => {
	return (
		<AuthGuard>
			<Sidebar>
				<FinancialPresentation />
			</Sidebar>
		</AuthGuard>
	);
};
